import type {MainCategoryGroupId} from '../schemas';

const SECTION_ID_PREFIX = 'mira-section';

/** Sticky-chrome offset shared by `scroll-margin-top` on headings and the scroll-spy `topOffset`. */
export const SECTION_SCROLL_OFFSET_PX = 96;

export function getSectionElementId(groupId: MainCategoryGroupId): string {
  return `${SECTION_ID_PREFIX}-${groupId}`;
}
